import Section from './DocumentsBlock'
import isEmpty from './DocumentsIsEmpty'
import Options from './DocumentsOptions'

export default { isEmpty, Section, Options }
